import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'

const Item = props => (
  <tr>
    <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
    <td> <span>{props.row.profile.profileId} </span></td>
    <td> <span>{props.row.bank ? props.row.bank.name : ''} </span></td>
    <td> <span>{props.row.accountNumber} </span></td>
    <td> <span>{props.row.accountName} </span></td>
    <td> <span>
      {props.row.isDefault === true
        ? 'Yes'
        : 'No'
      }
    </span></td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    profile: {
      profileId: '',
    },
    bank: {
      name: '',
    },
    accountNumber: '',
    accountName: '',
    isDefault: false,
  },
  skip: 0,
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      profileId: PropTypes.string.isRequired,
    }).isRequired,
    bank: PropTypes.shape({
      name: PropTypes.string,
    }),
    accountNumber: PropTypes.string.isRequired,
    accountName: PropTypes.string.isRequired,
    isDefault: PropTypes.bool.isRequired,
  }).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
